var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"10","height":"5","viewBox":"0 0 10 5","fill":"none"}},[_c('path',{attrs:{"d":"M0 0L5 5L10 0H0Z","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }